/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_CA_PATHS } from 'types/locales';
import { ACCESSIBILITY_PATH } from 'constants/urls';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_EXPLORE_EXP_LABEL,
            defaultValue: 'Explore eXp',
          },
          link: '/explore-exp',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_FIND_AGENT_LABEL,
            defaultValue: 'Find an Agent',
          },
          link: '/agents-search',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_JOIN_EXP_LABEL,
            defaultValue: 'Join eXp',
          },
          link: 'https://join.exprealty.ca',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_INVESTOR_RELATIONS_LABEL,
            defaultValue: 'Investor Relations',
          },
          link: 'https://expworldholdings.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_COMPANY_CAREERS_LABEL,
            defaultValue: 'Company Careers',
          },
          link: 'https://expworldholdings.com/careers/',
          target: '_blank',
          isAnchor: true,
        },
      ],
      column2: [
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_EXP_LIFE_LABEL,
            defaultValue: 'eXp Life',
          },
          link: 'https://life.exprealty.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_ZOOCASA_LABEL,
            defaultValue: 'Zoocasa',
          },
          link: 'https://zoocasa.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_SUCCESS_LABEL,
            defaultValue: 'Success',
          },
          link: 'https://www.success.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_QUEBEC_LISTINGS_LABEL,
            defaultValue: 'Quebec Listings',
          },
          link: 'https://expquebec.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_ACCESSIBILITY_LABEL,
            defaultValue: 'Accessibility',
          },
          link: ACCESSIBILITY_PATH,
          isAnchor: true,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_TERMS_AND_CONDITIONS_LABEL,
            defaultValue: 'Terms and Conditions',
          },
          link: 'https://expworldholdings.com/terms-of-service/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_PRIVACY_POLICY_LABEL,
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_COOKIE_POLICY_LABEL,
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_TERMS_AND_CONDITIONS_FR_LABEL,
            defaultValue: 'Modalités',
          },
          link: 'https://expworldholdings.com/terms-of-service-fr/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_PRIVACY_POLICY_FR_LABEL,
            defaultValue: 'Politique de confidentialité',
          },
          link: 'https://expworldholdings.com/privacy-policy-fr/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_SITEMAP_LABEL,
            defaultValue: 'Sitemap',
          },
          link: '/sitemap',
          target: '_blank',
          isAnchor: true,
        },
      ],
      bottom: [
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_DISCLOSURES_TRADEMARKS_LABEL,
              defaultValue: 'The trademarks MLS®, Multiple Listing Service® and the associated logos are owned by The Canadian Real Estate Association (CREA) and identify the quality of services provided by real estate professionals who are members of CREA. eXp Realty holds real estate brokerage licenses in multiple provinces. For information on licenses please contact us at info@exprealty.net',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_DISCLOSURES_LISTINGS_LABEL,
              defaultValue: 'For listings in Canada, the trademarks REALTOR®, REALTORS®, and the REALTOR® logo are controlled by The Canadian Real Estate Association (CREA) and identify real estate professionals who are members of CREA. The trademarks MLS®, Multiple Listing Service® and the associated logos are owned by CREA and identify the quality of services provided by real estate professionals who are members of CREA. Used under license.',
            },
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.ca',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-ca.png',
        alt: {
          key: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_IMAGE_ALT,
          defaultValue: 'Two people smiling while looking at a phone.',
        },
      },
    },
    showAccessibilityLink: true,
  };
}